import React from 'react';
import { useTranslation } from 'react-i18next';
import CreateMarketForm from '../components/Sellers/Profile/SetupMarketplace/components/CreateMarketForm';
import TitleText from '../components/atoms/TitleText';
import Button from '../components/atoms/Button';
import { useCreateMarketplaceMutation } from '../store/services/sellerProfileCreationService';
import { Breadcrumb } from 'antd';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { useGetSellersQuery } from '../store/services/addSellerService';

const SetupMarketplace: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { sellerId } = useParams<{ sellerId: string }>();
  
  const { data: sellersData, isLoading: sellersLoading } = useGetSellersQuery({
    page: 0,
    limit: 100,
  });
  
  const [createMarketplace, { isLoading: creatingMarket }] = useCreateMarketplaceMutation();

  const seller = sellersData?.payload?.content?.find((s: any) => s.profileId === sellerId);
  
  // Guard against re-entry if marketplace setup is already complete
  if (!sellersLoading && seller && !seller?.actions?.canSetupMarketPlace) {
    return <Navigate to={`/sellers/${sellerId}/profile`} replace />;
  }

  const handleHeaderSave = () => {
    const formElement = document.getElementById('create-marketplace-form') as HTMLFormElement | null;
    if (formElement) {
      formElement.requestSubmit();
    }
  };

  return (
    <div
      className="w-full bg-[#f3f4f6] dark:bg-[#090909] flex flex-col gap-6 transition-colors font-sans"
      data-testid="create-market-container"
    >
      <div className=" w-full mx-auto flex flex-col gap-6 px-4 lg:px-0" data-testid="create-market-wrapper">
        {/* Top Header Section */}
        <div
          className="flex flex-col md:flex-row md:items-center justify-between gap-4"
          data-testid="create-market-page-header"
        >
          <div className="flex flex-col gap-1" data-testid="setup-marketplace-title-container">
            <TitleText
              text={t('setupMarketplace.title', 'Setup marketplace')}
              className="text-[28px] font-bold text-[#090909] dark:text-white leading-tight font-sans"
              data-testid="setup-marketplace-title"
            />
            <Breadcrumb
              className="text-[#6B7280] dark:text-[#9CA3AF] text-[16px] font-normal mt-0.5"
              data-testid="setup-marketplace-breadcrumb"
              items={[
                { title: <span className="cursor-pointer hover:text-blue-500 font-normal transition-colors" onClick={() => navigate('/')}>{t('sellers.sellerProfile.breadcrumbs.dashboard', 'Dashboard')}</span> },
                { title: <span className="cursor-pointer hover:text-blue-500 font-normal transition-colors" onClick={() => navigate('/sellers')}>{t('sellers.sellerProfile.breadcrumbs.sellerList', 'Seller list')}</span> },
                { title: <span className="font-normal text-[#090909] dark:text-white">{t('setupMarketplace.breadcrumbActive', 'Add product')}</span> },
              ]}
            />
          </div>

          <div className="flex items-center gap-3 shrink-0" data-testid="setup-marketplace-header-actions">
            <Button
              type="button"
              onClick={handleHeaderSave}
              loading={creatingMarket}
              className="w-[270px] h-[46px] rounded-xl font-semibold text-base transition-all shadow-sm"
              data-testid="create-market-btn-save-header"
            >
              {t('setupMarketplace.save', 'Save')}
            </Button>
          </div>
        </div>

        {/* Main Content Form Card Wrapper */}
        <div className="w-full" data-testid="create-market-form-wrapper">
          <CreateMarketForm createMarketplace={createMarketplace} />
        </div>
      </div>
    </div>
  );
};

export default SetupMarketplace;

